import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-importa-postali',
  templateUrl: './importa-postali.component.html',
  styleUrls: ['./importa-postali.component.css']
})
export class ImportaPostaliComponent extends AppComponentGenericComponent implements OnInit {
	headers: HttpHeaders;
	uploader: FileUploader;
	uploadUrl: string = 'api/importa_postali';
	converterUrl: string;
	fileName: string;
	accept: string;
	acceptList: any[] = [
		{
			name : 'EXCEL',
			value : '.xls , .xlsx'
		},
		{
			name : 'CSV',
			value : '.csv'
		}
	]

	constructor(protected dataService: DataService) {
		super(dataService, 'import-postali');
		let serverUrl = this.dataService.getCommon().getDB().serverUrl;
		this.converterUrl = serverUrl+'/excel_to_db.php';
		this.headers = new HttpHeaders();
		this.headers.append('Content-Type', 'application/json');
		this.headers.append('Accept', 'application/json');
		this.uploader = new FileUploader({url: this.uploadUrl });
		this.uploader.onCompleteAll = () => {
			console.log("onCompleteAll ok");
			this.fileConversion();
		};
	}

	ngOnInit() {
		this.accept = this.acceptList[0].value;
	}

	removeFiles(){
		this.uploader.clearQueue();
	}

	uploadFile(item:any){
		item.file.name = this.fileName;
		item.upload();
	}

	fileConversion() {
		let body: any = {};

		this.dataService.getCommon().getHttpClient().post<any>(this.converterUrl, JSON.stringify(body),	{ headers: this.headers })
			.subscribe(
				response => {
					console.log(response);
				}
			);
	}

}
